import { render, staticRenderFns } from "./Segurados.vue?vue&type=template&id=45d9c368&scoped=true"
import script from "./Segurados.vue?vue&type=script&lang=js"
export * from "./Segurados.vue?vue&type=script&lang=js"
import style0 from "./Segurados.vue?vue&type=style&index=0&id=45d9c368&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d9c368",
  null
  
)

export default component.exports